import api from '@/lib/api';

const SID_KEY = 'jw_analytics_sid';

const genSid = () => {
  try {
    return (crypto.randomUUID && crypto.randomUUID()) || `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  } catch { return `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`; }
};

export const getSessionId = () => {
  let sid = null;
  try { sid = localStorage.getItem(SID_KEY); } catch { /* ignore */ }
  if (!sid || sid.length < 6) {
    sid = genSid();
    try { localStorage.setItem(SID_KEY, sid); } catch { /* ignore */ }
  }
  return sid;
};

/**
 * Fire-and-forget event tracker. Never throws — analytics must never break the UX.
 */
export const track = (event, meta = {}) => {
  try {
    const session_id = getSessionId();
    const payload = {
      session_id,
      event,
      path: (typeof window !== 'undefined' ? window.location.pathname : null),
      referrer: (typeof document !== 'undefined' ? (document.referrer || null) : null),
      meta,
    };
    // Best-effort — do NOT await
    api.post('/analytics/track', payload).catch(() => {});
  } catch { /* ignore */ }
};

/**
 * Link the current anon session to the logged-in user (best-effort).
 * Called right after successful login/register.
 */
export const identify = () => {
  try {
    const session_id = getSessionId();
    api.post('/analytics/identify', { session_id }).catch(() => {});
  } catch { /* ignore */ }
};
